var React = require('react');
var ReactNative = require('react-native');

var LinkingManager = require('./wrappers/LinkingManager');
var NetworkManager = require('./NetworkManager');

var {
  View,
  StyleSheet,
} = ReactNative;

var Twitter = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {

    }
  },

  getInitialState : function()
  {
    return {

    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  didUpdate : function(data)
  {

  },

  render: function()
  {
    return (<View />)
  }
});

Twitter.getCards = function(featureData, appActions, data)
{
  var didSelect = function()
  {
    Twitter.customNavigation(featureData, appActions);
  };
  var appManager = appActions._appManager;
  var iconName = featureData.data.icon.replace("fa-", "")
  var cards = [];
  if( typeof data.Twitter !== 'undefined' )
  {
    data.Twitter = data.Twitter.sort(function(a,b)
    {
      return (new Date(b.created_at)).getTime() - (new Date(a.created_at)).getTime();
    });

    var MAX_TWITTER_POSTS = 1;
    for( var i = 0; i < data.Twitter.length && i < MAX_TWITTER_POSTS; i++ )
    {
      var twit = data.Twitter[i];
      var message = twit.text;
      var date = new Date(twit.created_at)

      var dateText = appManager.getLocalizationManager().localizedLongDate(date.getTime());
      var sortOrder = (new Date()).getTime() - (date.getTime());
      var media = (typeof twit.entities !== 'undefined') && (typeof twit.entities.media !== 'undefined') ? twit.entities.media : [];
      cards.push({
        key : "twit-"+twit.id,
        didSelect : didSelect,
        smallTitle : dateText,
        body1 : message,
        media : media,
        icon : iconName,
        cardType : 0,
        sortOrder : sortOrder
      })
    }
  }
  //console.log(cards)
  return cards;
}
Twitter.customNavigation = function(featureData, appActions)
{
  var twitterURL = "twitter://"+featureData.data.twitter_screen_name;
  LinkingManager.canOpenURL(twitterURL, function(can)
  {
    if( can )
    {
      LinkingManager.openURL(twitterURL)
    }
    else
    {
      var url = "http://www.twitter.com/"+featureData.data.twitter_screen_name;
      var appManager = appActions._appManager;
      var barTintColor = appManager.getColorForKey("HeaderColor");
      var tintColor = appManager.getColorForKey("HeaderIconColor");

      LinkingManager.openURL(url, tintColor, barTintColor);
    }
  })
}
// Twitter.customDependencyKeys = ["Twitter"];
// Twitter.customDataDependency = function(appManager, completion)
// {
//   var featureData = appManager.getFeatureForName("Twitter");
//   NetworkManager.getTwitterInfo(appManager, featureData.data.twitter_screen_name, function(data)
//   {
//     var filteredData = [];
//     for( var i = 0; i < data.length; i++ )
//     {
//       var thisData = data[i];
//       var media = (typeof thisData.entities !== 'undefined') && (typeof thisData.entities.media !== 'undefined') ? thisData.entities.media : [];
//       var newMedia = [];
//       for( var j = 0; j < media.length; j++ )
//       {
//         if( typeof media[j].media_url_https !== 'undefined' )
//         {
//           newMedia.push({media_url_https:media[j].media_url_https})
//         }
//       }
//       filteredData.push({created_time:thisData.created_time, created_at:thisData.created_at, text:thisData.text, entities:{media:newMedia}})
//     }
//     appManager.setData({Twitter:filteredData}, function()
//     {
//       completion({Twitter:filteredData})
//     })
//   }, function(a)
//   {
//     completion({})
//   }, function()
//   {
//     completion({})
//   })
// }

Twitter.dataDependencies = [];

module.exports = Twitter;
